import {match} from 'ts-pattern';

import {WORKSHOP_WIDGET_GROUPS, WorkshopGroupKey, WorkshopLeafKey} from './workshopWidgetGroups';

const ALL_WORKSHOP_WIDGETS: readonly WorkshopLeafKey[] = WORKSHOP_WIDGET_GROUPS.flatMap((group) =>
  group.widgets.map((widget) => widget.key)
);

/**
 * Widget keys affected when an aggregate toggle (workshop overview or a group)
 * is switched — the caller applies the toggle value to each returned key.
 */
export const getWorkshopLeafKeys = (
  target: 'overview' | WorkshopGroupKey
): readonly WorkshopLeafKey[] =>
  match(target)
    .with('overview', () => ALL_WORKSHOP_WIDGETS)
    .with(
      'workshopCritical',
      'workshopWarning',
      'workshopToday',
      (groupKey) =>
        WORKSHOP_WIDGET_GROUPS.find((group) => group.groupKey === groupKey)?.widgets.map(
          (widget) => widget.key
        ) ?? []
    )
    .exhaustive();
